var map = {
	"./ImageCarousel": 658,
	"./ImageCarousel.js": 658,
	"./images/image1.jpg": 326,
	"./images/image2.jpg": 154,
	"./images/image3.jpg": 831,
	"./images/image4.jpg": 778,
	"./images/image5.jpg": 126,
	"./images/image6.jpg": 316,
	"./styles.module.css": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;